import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';

class SuccessModalController {
    constructor(modal) {
        if (!modal) {
            return;
        }
        this.modal = modal;
        this.closeBtn = this.modal.querySelector('[data-close-modal]');
        this.init();
    }

    init() {
        this.closeBtn.addEventListener('click', () => {
            this.close();
        })
    }

    open() {
        this.modal.classList.add('final-modal--open');
        lockScroll();
    }

    close() {
        this.modal.classList.remove('final-modal--open');
        unlockScroll();
    }
}

(()=> {
    const successModal = document.querySelector('.final-modal');
    const instanceSuccessModal = new SuccessModalController(successModal);
    window.initModal = instanceSuccessModal;
})();
